import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import mapStyles from './GolfCourseMapStyles'
import config from 'react-global-configuration';

import { Heading2, FullAreaWrapper, Heading4, Select, SelectWrapper, Text, GridRow, TextLink, Centered } from './MarketingStyles';
import GolfCourseMarker from './GolfCourseMarker';

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import GoogleMap from 'google-map-react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'

import { Arrow } from '../../images/icons/Icons';
import LeadingBadgeImage from '../../images/icons/leading_badge.png';
import HotelMarker from './HotelMarker';

@inject('golfCourseStore', 'utilStore')
@observer
class GolfCourseMap extends Component {

  constructor(props) {
    super(props)
    this.state = {
      selectedCourse: undefined,
      selectedRegion: undefined,
      index: 0,
    }
  }

  // load all active courses
  // add to list
  // when list changes rerender map (automatic)

  selectCourse = (id) => {
    this.setState({ selectedCourse: id })
  }

  // used when clicked from selection
  selectCourseAndCenter = (id) => {
    this.selectCourse(id);
    // TODO center map on course
  }

  componentDidMount() {
    // this.props.golfCourseStore.getGolfCourses()
  }

  render() {

    const { isPhone, isTablet, regions } = this.props.utilStore

    console.log("REGIONS", regions);
    if(!regions) return

    let courses = this.props.golfCourseStore.golfCourses
    let coursesDirectus = this.props.utilStore.golfcoursesDirectus

    console.log('courses', courses)
    console.log('coursesDirectus', courses)

    // Copy region from parse golfcourse data to directus golfcourse data

    if(!courses || !coursesDirectus) return <div></div>

    for (const cd of coursesDirectus) {
      for (const c of courses) {
        if (cd.key === c.key) {
          cd.region = c.region
          cd.isLeading = c.isLeading
        }
      }
    }

    coursesDirectus = coursesDirectus && coursesDirectus.filter(course => this.state.selectedRegion ? course.region && course.region.slug === this.state.selectedRegion : true)

    const hotels = coursesDirectus.reduce((acc, course) => {
      if(!course.hotels) return 
      
      course.hotels.forEach(hotel => {
        if(!hotel || !hotel.hotels_id) return
        if(acc.find(h => h.id === hotel.id)) return
        if(hotel.hotels_id.lat === null || hotel.hotels_id.lat === null) return
        
        acc.push({...hotel.hotels_id, region: course.region})
      })

      return acc
    }, []).filter(hotel => this.state.selectedRegion ? hotel.region && hotel.region.slug === this.state.selectedRegion : true)


    const coursesAndHotels = [...coursesDirectus, ...hotels]

    const hasNext = coursesAndHotels && this.state.index < coursesAndHotels.length - 1
    const hasPrev = coursesAndHotels && this.state.index > 0
    

    const CourseItem = ({ course }) => {
      return (
        <CourseListItem>
          <CourseListImageWrapper>
            <CourseListImage src={ `${config.get('DIRECTUS_BACKEND')}assets/${ course.title_image.id }?key=medium` } alt=""/>
            <CourseTypeCourse>Golfclub</CourseTypeCourse>
          </CourseListImageWrapper>
          <CourseListContentWrapper>
            { course.isLeading && <LeadingBadgeWrapper><img src={ LeadingBadgeImage || '' } /></LeadingBadgeWrapper> }
            <CourseListContent>
              <Heading4>{ course.name } </Heading4>
              <Text>{ course.region ? course.region.title : '' }</Text>
              <Seperator />
              <Text>{ course.address }</Text>
              {/* { course.website && <TextLink href="">{ course.website }</TextLink> } */}
            </CourseListContent>
          </CourseListContentWrapper>
        </CourseListItem>
    )}

    const HotelItem = ({ hotel }) => {
      return (
        <CourseListItem>
          <CourseListImageWrapper>
            <CourseListImage src={ `${config.get('DIRECTUS_BACKEND')}assets/${ hotel.image && hotel.image.id }?key=medium` } alt=""/>
            <CourseTypeHotel>Hotel</CourseTypeHotel>
          </CourseListImageWrapper>
          <CourseListContentWrapper>
            <CourseListContent>
              <Heading4>{ hotel.name } </Heading4>
              {/* <Text>{ hotel.region ? hotel.region.title : '' }</Text> */}
              {/* <Seperator />
              <Text>{ hotel.address }</Text> */}
              {/* { course.website && <TextLink href="">{ course.website }</TextLink> } */}
            </CourseListContent>
          </CourseListContentWrapper>
        </CourseListItem>
    )}


    return (
      <ContentWrapper> { /* TODO: make overflow hidden so markers dont render outside of map (happens on first load )*/}
        <MapWrapper>
          <GoogleMap
            defaultZoom={isPhone ? 6 : 7}
            defaultCenter={{ lat: 47.6964719, lng: this.props.showPanel && !isTablet ? 9 : 13.3457347 }}
            bootstrapURLKeys={{ key: 'AIzaSyAhpIoE9Oegu_akwWd0XTSArEANn57Q8fQ' }}
            options={{
              styles: mapStyles,
              disableDefaultUI: false,
            }}
          >
            {
              coursesDirectus && coursesDirectus.map(course =>
                course.lat && course.lng &&
                <GolfCourseMarker
                  key={ course.id }
                  lat={ course.lat }
                  lng={ course.lng }
                  courseData={ course }
                  selectCourse={ () => this.selectCourse(course.id) }
                  deselectCourse={ () => this.selectCourse() }
                  selected={ this.state.selectedCourse === course.id }
                />
              )
            }
            {
              hotels && hotels.map(hotel =>
                hotel.lat && hotel.lng &&
                <HotelMarker
                  key={ hotel.id }
                  lat={ hotel.lat }
                  lng={ hotel.lng }
                  hotelData={ hotel }
                  select={ () => this.selectCourse('h' + hotel.id) }
                  deselect={ () => this.selectCourse() }
                  selected={ this.state.selectedCourse === 'h' + hotel.id }
                />
              )
            }
          </GoogleMap>
        </MapWrapper>
          { this.props.showPanel &&
            <Panel>
              <PanelInformationWrapper>
                <Heading4>Golfclubs & Hotels</Heading4>
                <Heading2>Entdecken Sie alle Golfclubs und Hotels die Teil von THE LOGE sind</Heading2>
                <GridRow desktop="1fr 1fr">
                  <Text style={{ alignSelf: "center" }}>Region:</Text>
                  <SelectWrapper>
                    <Select onChange={ e => this.setState({ selectedRegion: e.target.value}) } defaultValue="">
                      <option value="">Alle Golfclubs & Hotels</option>
                      { regions && regions.map((item, index) => <option key={item.slug} value={item.slug}>{item.title}</option>) }
                    </Select>
                  </SelectWrapper>
                </GridRow>
              </PanelInformationWrapper>
              { !isTablet ?
                <CourseList>
                  { ( coursesDirectus && coursesDirectus.length > 0 ) && 
                      coursesDirectus.map(course =>
                        <CourseItem key={course.id} course={ course } />
                      )
                  }

                  { ( hotels && hotels.length > 0 ) && 
                      hotels.map(hotel =>
                        <HotelItem key={'h'+hotel.id} hotel={ hotel } />
                      )
                  }
                  { !( coursesDirectus && coursesDirectus.length > 0 ) && !( hotels && hotels.length > 0 ) &&
                    <Centered>Es sind noch keine Golfclubs oder Hotels in dieser Region verfügbar</Centered>
                  }
                  <div style={{ height: 30 }}></div>
                </CourseList>
              :
                <div>
                  <CourseCarousel
                    key="press-carousel"
                    autoPlay centerMode centerSlidePercentage="100" showArrows={false} autoPlay={false} showStatus={false} showIndicators={false} showThumbs={false}
                    onChange={ index => this.setState( { index } ) }
                    selectedItem={ this.state.index }
                  >
                    { ( coursesDirectus && coursesDirectus.length > 0 ) && 
                        coursesDirectus.map(course =>
                          <CourseItem key={course.id} course={ course } />
                        )
                    }

                    { ( hotels && hotels.length > 0 ) && 
                        hotels.map(hotel =>
                          <HotelItem key={'h'+hotel.id} hotel={ hotel } />
                        )
                    }

                    { !( coursesDirectus && coursesDirectus.length > 0 ) && !( hotels && hotels.length > 0 ) &&
                      <Centered>Es sind noch keine Golfclubs oder Hotels in dieser Region verfügbar</Centered>
                    }
                  </CourseCarousel>
                  <NavigationWrapper>
                      <NavigationButton enabled={hasPrev} onClick={ () => hasPrev ? this.setState( { index: this.state.index - 1 } ) : '' }><Arrow size="2em" rotation="180deg" /></NavigationButton>
                      <NavigationButton enabled={hasNext} onClick={ () => hasNext ? this.setState( { index: this.state.index + 1 } ) : '' }><Arrow size="2em" /></NavigationButton>
                  </NavigationWrapper>
                </div>
              }
            </Panel>
          }
      </ContentWrapper>
    )
  }
}

export default GolfCourseMap

const CourseCarousel = styled(Carousel) `
  margin: 0 -10px;
  padding-top: 50px;
`

const MapWrapper = styled(FullAreaWrapper) `

  ${cssVar.breakpoints.tablet} {
    height: 500px;
  }
`

const ContentWrapper = styled(FullAreaWrapper) `
  position: relative;

  ${cssVar.breakpoints.tablet} {
    height: auto;
  }
`

const Panel = styled.div `
  position: absolute;
  display: flex;
  flex-direction: column;
  background: white;
  top: 50px;
  right: 50%;
  height: calc( 100% - 100px );
  width: calc( 50% - 50px );
  max-width: calc( ${cssVar.max_content_width / 2 }px );
  border-radius: 2px;

  ${cssVar.breakpoints.tablet} {
    position: static;
    height: auto;
    margin: 0 auto;
    width: 100%;
    padding: 30px;
  }
`

const PanelInformationWrapper = styled.div `
  width: calc(100% - 100px);
  margin: 50px 50px 10px 50px;
  padding-bottom: 20px;
  border-bottom: 2px solid ${ cssVar.colors.blue };

  ${cssVar.breakpoints.tablet} {
    width: 100%;
    margin: 0;
    padding: 30px 0;
  }
`

const CourseList = styled.div `
  width: 100%;
  overflow: auto;
  flex: 1;
  padding: 10px 50px 50px 50px;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr;
  grid-gap: 20px;
`

const CourseListItem = styled.div `
  display: block;
  width: 100%;
  background: ${ cssVar.colors.lightest_grey };
  display: grid;
  grid-template-columns: 1fr 2fr;

  ${cssVar.breakpoints.tablet} {
    height: 100%;
    width: calc(100% - 20px);
    margin: 0 10px;
  }

  ${cssVar.breakpoints.tablet} {
    grid-template-columns: 1fr;
  }
`

const CourseListImageWrapper = styled.div `
  width: 100%;
  height: 100%;
  position: relative;
  min-height: 200px;

  ${cssVar.breakpoints.tablet} {
    height: 200px;
  }
`
const CourseListImage = styled.img `
  width: 100%;
  height: 100%;
  object-fit: cover;

  ${cssVar.breakpoints.tablet} {
    height: 200px;
  }
`
const CourseTypeCourse = styled.div `
  position: absolute;
  left: 8px;
  top: 8px;
  background: ${ cssVar.colors.blue };
  color: white;
  border-radius: 4px;
  padding: 4px 8px;
`

const CourseTypeHotel = styled.div `
  position: absolute;
  left: 8px;
  top: 8px;
  background: ${ cssVar.colors.light_grey };
  color: ${ cssVar.colors.blue };
  border-radius: 4px;
  padding: 4px 8px;
`

const CourseListContentWrapper = styled.div `
  width: 100%;
`

const CourseListContent = styled.div `
  width: 100%;
  padding: 30px;
`

const LeadingBadgeWrapper = styled.div `
  width: 100%;
  background: ${ cssVar.colors.gold };
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 30px;

  img {
    height: 30px;
    width: 100%;
    object-fit: contain;
    object-position: center;
  }
`

const Seperator = styled.div `
  width: 100%;
  border-bottom: 2px solid ${ cssVar.colors.blue };
`

const NavigationWrapper = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  padding-top: 30px;
`

const NavigationButton = styled.div `
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 10px calc(20px - 1em) 10px 20px;
  border: 2px solid ${props => props.enabled ? cssVar.colors.blue : cssVar.colors.grey};
  color: ${props => props.enabled ? cssVar.colors.blue : cssVar.colors.grey};
  border-radius: 2px;
  cursor: ${props => props.enabled ? 'pointer' : 'not-allowed'};

  text-align: center;

  width: 100%;
`



// WEBPACK FOOTER //
// /src/components/marketing/GolfCourseMap.js